import { ProductPartnership } from "@/shared/enums/product-partnership.enum";
import { Meta } from "@/shared/models/api.model";
import { StorePartnershipState } from "@/shared/models/store-partnership.model";

function state(): StorePartnershipState {
  return {
    claim: {},
    claims: [],
    claimsMeta: {} as Meta,
    claimHistory: {},
    partners: [],
    policies: [],
    policiesMeta: {} as Meta,
    policy: {},
    product: ProductPartnership.Default,
    uploadProgress: 0,
    productList: [],
    invoices: [],
    invoicesMeta: {} as Meta,
    invoice: {},
    invoiceHistory: {},
    claimsDisbursement: [],
    claimsDisbursementMeta: {} as Meta,
    claimDisbursementDetail: {},
    claimDisbursementHistory: {},
    claimPools: [],
    claimPoolsMeta: {} as Meta,
    claimPool: {},
    gadgets: [],
    gadgetsMeta: {},
    gadgetsAll: [],
    gadgetCategory: [],
    listBrand: [],
  };
}

export default state;
